import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import PdfIcon from './PdfIcon'
import { FormattedMessage } from 'react-intl'
import StatusOP from './StatusOp'
import classNames from 'classnames'
import { Releve } from '../account_model'

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	cardContainer: {
		display: 'flex',
		padding: '16px 0px',
		borderTop: `1px solid ${theme.palette.blue['10']}`
	},
	divFlex: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	flexDirectionRow: {
		flexDirection: 'row'
	},
	flexDirectionColumn: {
		flexDirection: 'column'
	},
	mttSpan: {
		whiteSpace: 'pre'
	},
	opType: {
		padding: '12px 0px'
	}
}))

interface AcceptingProps {
	operation: Releve,
	setOpenPayment: (amount: number, facture: string, piece_numero: string) => void,
	paymentDisabled: boolean
}

type CardOpProps = AcceptingProps

const CardOp: React.FC<CardOpProps> = (
	{
		operation,
		setOpenPayment,
		paymentDisabled
	}
) => {
	const classes = useStyle()
	const cardContainerClass = classNames(
		classes.cardContainer,
		classes.flexDirectionColumn
	)

	const dateClass = classNames(
		classes.text9_opacity,
		classes.medium,
		classes.colorBlue
	)

	const operationTypeClass = classNames(
		classes.text8,
		classes.semiBold,
		classes.colorBlue,
		classes.opType
	)

	const montantClass = classNames(
		classes.text4,
		classes.semiBold,
		classes.colorBlue,
		classes.mttSpan
	)

	return (
		<div className={cardContainerClass}>
			<span className={dateClass}>
				{operation.date_exigible?.toLocaleDateString()}
			</span>
			<div className={classes.divFlex}>
				<span className={operationTypeClass}>
					{operation.operation_type}
				</span>
				<PdfIcon operation={operation} />
			</div>
			<div className={classes.divFlex}>
				<span className={montantClass}>
					{
						operation.operation_mtcredit ?
							`+ ${Number(operation.operation_mtcredit).toLocaleString()}`
							:
							`- ${Number(operation.operation_mtdebit).toLocaleString()}`
					}
					<FormattedMessage
						id="contracts.account.euro"
						defaultMessage=" €"
						description="Account euro"
					/>
				</span>
				<StatusOP
					paymentDisabled={paymentDisabled}
					mttcRestant={operation.facture_mttcrestant}
					isPartial={operation.facture_mttcrestant !== operation.operation_mtdebit}
					isCredit={!!operation.operation_mtcredit}
					setOpenPayment={setOpenPayment}
					factureLabel={operation.operation_type}
					pieceNumero={operation.piece_numero}
					numBail={operation.bail_ref}
				/>
			</div>
		</div>
	)
}

export default CardOp
